module.exports = __webpack_public_path__ + "static/assets/051be3880169afcd1d8f2f4c0b11f381.svg";